import { errorSixSvgData } from '../../../../Data/OtherPage/OtherPage'
import CommonError from '../Common/CommonError'

const Error503Container = () => {
  return (
    <CommonError errorSvg={errorSixSvgData} />
  )
}

export default Error503Container